import type { HsMatrix4 } from '../../math-new/objects/matrix4.class';

export function hsSortByCameraDistance<T extends { worldMatrix: HsMatrix4 }>(
  objects: T[],
  cameraMatrix: HsMatrix4,
  descending: boolean
): void {
  if (objects.length < 2) {
    return;
  }
  const entries: { object: T; distance: number }[] = objects.map((object: T) => ({
    object,
    distance: object.worldMatrix.distance(cameraMatrix),
  }));
  entries.sort((a: { object: T; distance: number }, b: { object: T; distance: number }) =>
    descending ? b.distance - a.distance : a.distance - b.distance
  );
  for (let index: number = 0; index < entries.length; index++) {
    objects[index] = entries[index].object;
  }
}
